/**
 * Costanti utilizzate dall'applicazione parent che ospita altre applicazioni
 * attraverso iframe, per dialogare/condividere informazioni
 */

const PluginMessageTypes = {
  // messaggio mandato al parent per confermare il caricamento dell'iframe
  LOADED: 'loaded',
  // messaggio per iframe per fargli forzare il reload ad un certo url
  RELOAD: 'reload',
  // messaggio per l'iframe che comunica il cambiamento di ufficio
  CHANGE_OFFICE: 'change_office',
  // messaggio per il parent con il quale l'iframe comunica il cambiamento di hash
  CHANGE_HASH: 'change_hash',
  // messaggio per il parent con il quale l'iframe comunica il cambiamento di hash (nuova versione)
  CHANGE_HASH2: 'change_hash2',
  // messaggio utilizzato per inoltrare eventi signalR
  SERVER_EVENT: 'server_event',
  // messaggio mandato al parent per indicare l'evento di focus all'interno dell'iframe
  FOCUS: 'focus',
  // messaggio mandato al parent per indicare la dimensione del dialog mostrato nell'iframe
  DIALOG_SIZE: 'dialog_size',
  // messaggio mandato al parent per indicare l'evento "OK"
  DIALOG_OK: 'dialog_ok',
  // messaggio mandato al parent per indicare l'evento "CANCEL"
  DIALOG_CANCEL: 'dialog_cancel',
  // messaggio per navigare ad uno specifico hash al di fuori dell'iframe
  GOTO_EXTERNAL_HASH: 'goto_external_hash',
  // messaggio per navigare ad uno specifico url al di fuori dell'iframe
  GOTO_EXTERNAL_URL: 'goto_external_url',
  // messaggio per il parent per chiedere una chiamata api al backend di parent
  CALL_FORWARD: 'call_forward',
  // messaggio per l'iframe che ritorna al mittente la response della richiesta fatta
  CALL_FORWARD_RESPONSE: 'call_forward_resp',
  // messaggio inviato dal child al parent per simulare la presenza di un modale
  MODALIZER: 'modalizer',
  // messaggio inviato dal parent verso il child per indicare che si sta cliccando durante una modalizzazione
  MODALIZER_CLICK: 'modalizer_click',
  // messaggio per il parent per riattivare l'evento di click outside temporaneamente
  // bloccato dal child
  CLICK_OUTSIDE_RESTORE: 'click_outside_restore',
  // messaggio inviato dal parent al child se passati degli extraParams.
  // Verrà inviato subito dopo l'avvenuto caricamento del child
  EXTRA_PARAMS: 'extra_params',
  // messaggio per il figlio mandato dal padre quando cambia la resolution
  SET_RESOLUTION: 'set_resolution',
  // messaggio per chiedere ai parent l'url del browser
  GET_ROOT_LOCATION: 'get_root_location',
};

// parametro inviato in querystring all'iframe per indicargli la chiamata dal parent
const ParentCallerUrlParam = 'parentCaller';

// className che identifica un IFrame
const IFrameClassName = 'fw-plugins-iframe';

const PluginCallsTypes = {
  // chiamata scambiata tra parent e application per capire se il child è impegnato
  // in una operazione
  IS_CLICKABLE_OUTSIDE: 'is_clickable_outside',
};

// parametro inviato in querystring dal ModalIFrame al child per indicargli la gestione del resize
const ParentModalCaller = 'parentModalCaller';

// parametro inviato in querystring dal parent per definire la sua risoluzione.
const ParentResolution = 'parentResolution';
export {
  PluginMessageTypes,
  ParentCallerUrlParam,
  PluginCallsTypes,
  IFrameClassName,
  ParentModalCaller,
  ParentResolution,
};
